export { ChevronDoubleLeft as default } from './ChevronDoubleLeft';
